<template>
  <mon-target-info-section
    v-if="detailInfo.length"
    :detailFilter="detailInfo"
    :target-data="getTargetData"
    :product-type-code="productTypeCode"
    :chip-items="chipItems"
    :customFields="customFieldValue"
  ></mon-target-info-section>
</template>

<script>
import _ from 'lodash';
import monTargetMixin from '../../../popup/monTarget.mixin';
import { PRODUCT_TYPES } from '@/containers/utils/constant.js';
import MonTargetInfoSection from '@/containers/popup/MonTargetInfoSection.vue';

export default {
  mixins: [monTargetMixin],
  components: { MonTargetInfoSection },
  props: {
    productTypeCode: {
      type: [String, Number],
      default: ''
    },
    targetData: {
      type: Object,
      default: () => {}
    },
    productId: {
      type: [String, Number],
      default: ''
    },
    productIp: {
      type: [String, Number],
      default: ''
    },
    productLbServiceIp: {
      type: [String, Number],
      default: ''
    },
    chipItems: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      getTargetData: this.targetData,
      detailInfo: [],
      monSchema: {},
      productAttachmentType: '',
      productSegmentName: '',
      productAccessLocation: '',
      networkName: '',
      productNetworkName: '',
      productVpnGwName: '',
      productLocalTunnelIp: '',
      productPeerTunnelIp: '',
      productPeerVpnGatewayIp: '',
      productRemoteSubnet: '',
      productServiceRepl: '',
      productWebRepl: '',
      productDriverPod: '',
      productExecPod: '',
      productQueryEngineType: '',
      productAutoscaling: '',
      productClusSizeCpu: '',
      productClusSizeMem: '',
      productMaxQuery: '',
      productInfo: '',
      productDisk: '',
      productStorageInfo: '',
      productOs: '',
      productDbVersion: '',
      productProtocol: '',
      productSize: '',
      productSvcCount: '',
      productVpcName: '',
      productSubnetName: '',
      productNodeCount: '',
      productMaxNodeCount: '',
      productLbName: '',
      productLbLayerType: '',
      productEsType: '',
      productClusterName: '',
      productHaType: '',
      productSaType: '',
      serviceDomain: '',
      productConnectedVPC: '', // 연결 vpc
      dstTgwName: '',
      drUseYn: '',
      accessControlYn: '',
      podCount: '',
      hpcNodeCount: '',
      dataOpsClusterName: '',
      vpcIsIGW: 'N',
      startDate: '',
      endDate: '',
      resourceName: '',
      logging: '',
      endpointType: '',
      endpoint: '',
      productNodeType: '',
      lbSize: '',
      regionZone: '',
      sparkTotalCore: '',
      sparkTotalMemory: '',
      connectedVpcItems: '',
      detailFilter: {},
      vpcId: '',
      PRODUCT_TYPES: PRODUCT_TYPES
    };
  },
  computed: {
    isVpc() {
      return this.productTypeCode === 'VPC';
    },
    isCdn() {
      return this.productTypeCode === 'CDN';
    },
    displayClusterName() {
      return this.productTypeCode === 'MULTINODE-GPU'
        ? this.monSchema.gpuClusterName
        : this.monSchema.clusterName;
    },
    isHPCCluster() {
      return this.productTypeCode === 'HPCCluster';
    },
    isDataOpsDataFlow() {
      return this.productTypeCode === 'DataOps' || this.productTypeCode === 'DataFlow';
    },
    getClusterName() {
      return this.isDataOpsDataFlow ? this.dataOpsClusterName : this.productClusterName;
    },
    isBlockStorage() {
      return ['VM', 'Bare Metal Server', 'VM-GPU', 'MULTINODE-GPU'].includes(this.productTypeCode);
    },
    customFieldValue() {
      return {
        dataOpsClusterName: this.dataOpsClusterName,
        productClusterName: this.productClusterName,
        productDisk: this.productDisk,
        productStorageInfo: this.productStorageInfo,
        productProtocol: this.productProtocol,
        serviceDomain: this.serviceDomain,
        vpcId: this.vpcId,
        vpcIsIGW: this.vpcIsIGW,
        hpcNodeCount: this.hpcNodeCount,
        podCount: this.podCount,
        sparkTotalMemory: this.sparkTotalMemory
      };
    }
  },
  watch: {
    targetData(value) {
      this.getTargetData = value;
      if (value) {
        this.getInfoDetails(value, value.productInfoAttrs || []);
      }
    }
  },
  created() {
    this.getProductInfoFilter();
    this.setLabel();
  },
  mounted() {
    this.getProductCondition();
  },
  methods: {
    async getProductCondition() {
      let params = {
        productTypeCode: this.productTypeCode,
        conditionType: 'metric'
      };
      if (this.productTypeCode === 'KAFKA') params.productSq = this.productId;

      await this.$http.product
        .getProductConditions(params.productTypeCode, params.conditionType, params.productSq, true)
        .then((data) => {
          if (this.$util.isNotEmpty(data) && data.detailList) {
            this.detailInfo = data.detailList;
          }
        })
        .catch((err) => {
          if (err && err.code == 'AccessDenied') {
            this.$alert(err);
          }
        });
    },

    mappingAttributesAndAction() {
      return {
        diskSize: {
          attribute: 'productDisk'
        },
        storageInfo: {
          attribute: 'productStorageInfo',
          action: (attrValue) => {
            return attrValue === '' || attrValue === null ? this.monSchema.noData : attrValue;
          }
        },
        osInfo: {
          attribute: 'productOs'
        },
        type: {
          attribute: 'productInfo'
        },
        dbVersion: {
          attribute: 'productDbVersion'
        },
        protocol: {
          attribute: 'productProtocol'
        },
        size: {
          attribute: 'productSize'
        },
        svcCount: {
          attribute: 'productSvcCount'
        },
        vpcName: {
          attribute: 'productVpcName'
        },
        regionZone: {
          attribute: 'regionZone'
        },
        lbSize: {
          attribute: 'lbSize'
        },
        subnetName: {
          attribute: 'productSubnetName'
        },
        lbName: {
          attribute: 'productLbName'
        },
        esType: {
          attribute: 'productEsType'
        },
        clusterName: {
          attribute: 'productClusterName'
        },
        haType: {
          attribute: 'productHaType'
        },
        saType: {
          attribute: 'productSaType'
        },
        connectedVPC: {
          attribute: 'connectedVpcItems',
          action: (attrValue) => {
            const connectedVpcItems = attrValue.replace(/[[\]]/g, '').split(',');
            this.getTargetData = { ...this.getTargetData, connectedVpcItems };
            return connectedVpcItems;
          }
        },
        dstTgwName: {
          attribute: 'dstTgwName'
        },
        drUseYn: {
          attribute: 'drUseYn',
          action: (attrValue) => this.isUsePresent(attrValue)
        },
        accessControlYn: {
          attribute: 'accessControlYn',
          action: (attrValue) => this.isUsePresent(attrValue)
        },
        resourceName: {
          attribute: 'resourceName'
        },
        logging: {
          attribute: 'logging',
          action: (attrValue) => (attrValue === 'Y' ? this.monSchema.useY : this.monSchema.useN)
        },
        endpointType: {
          attribute: 'endpointType'
        },
        endpoint: {
          attribute: 'endpoint'
        },
        attachmentType: {
          attribute: 'productAttachmentType'
        },
        segmentName: {
          attribute: 'productSegmentName'
        },
        accessLocation: {
          attribute: 'productAccessLocation'
        },
        networkName: {
          attribute: 'productNetworkName'
        },
        vpnGatewayName: {
          attribute: 'productVpnGwName'
        },
        localTunnelIp: {
          attribute: 'productLocalTunnelIp'
        },
        peerTunnelIp: {
          attribute: 'productPeerTunnelIp'
        },
        peerVpnGatewayIp: {
          attribute: 'productPeerVpnGatewayIp'
        },
        remoteSubnet: {
          attribute: 'productRemoteSubnet'
        },
        nodeType: {
          attribute: 'productNodeType'
        },
        serviceInfo: {
          attribute: 'productServiceRepl'
        },
        webInfo: {
          attribute: 'productWebRepl'
        },
        queryEngineType: {
          attribute: 'productQueryEngineType'
        },
        autoscaling: {
          attribute: 'productAutoscaling',
          action: (attrValue) => (attrValue === 'N' ? 'Unused' : 'Used')
        },
        clusSizeCpu: {
          attribute: 'productClusSizeCpu'
        },
        clusSizeMem: {
          attribute: 'productClusSizeMem'
        },
        maxQuery: {
          attribute: 'productMaxQuery'
        },
        sparkTotalCore: {
          attribute: 'sparkTotalCore'
        },
        sparkTotalMemory: {
          attribute: 'sparkTotalMemory'
        }
      };
    },

    getInfoDetails(infos, attrs = []) {
      let layerType;
      let protocolType;
      const attributesAndAction = this.mappingAttributesAndAction();

      for (let i = 0; i < attrs.length; i++) {
        let attrItem = attrs[i];
        const { attrName, attrValue } = attrItem;
        this.targetData[attrName] = attrValue;

        if (attrName === 'maxNodeCount' && !this.isHPCCluster) this.productMaxNodeCount = attrValue;

        if (attrName === 'layerType') layerType = attrValue;

        if (attrName === 'protocol') protocolType = attrValue;

        if (!['maxNodeCount', 'layerType'].includes(attrName)) {
          const handler = attributesAndAction[attrName];

          if (handler) {
            this[handler.attribute] = Object.hasOwn(handler, 'action')
              ? handler.action(attrValue)
              : attrValue;
          }
        }

        if (this.isHPCCluster) {
          this.detailFilter.nodeCount = false;
          this.detailFilter.hpcNodeCount = true;
        }

        if (this.productTypeCode === 'Kubernetes') {
          if (
            attrName === 'maxNodeCount' &&
            ((attrValue === 'null' ? null : attrValue) || 0) <= 0
          ) {
            if (attrValue.length) {
              this.productNodeCount = 0;
            } else {
              this.productNodeCount = this.monSchema.noData;
            }
          }
        }

        if (this.isVpc && attrName === 'isIGW') {
          this.vpcIsIGW = attrValue;
        }

        if (this.productTypeCode === 'KAFKA' && attrName !== 'diskSize' && attrValue.length === 0) {
          this.detailFilter.diskSize = true;
          this.productDisk = this.monSchema.noData;
        }

        if (this.productTypeCode === 'File Storage(New)') {
          if (attrName !== 'type' && attrValue.length === 0) {
            this.detailFilter.type = true;
            this.productInfo = this.monSchema.noData;
          }
          if (attrName !== 'protocol' && attrValue.length === 0) {
            this.detailFilter.protocol = true;
            this.productProtocol = this.monSchema.noData;
          }
        }
      }

      if (typeof layerType != 'undefined' && typeof protocolType != 'undefined') {
        this.productLbLayerType = layerType + '  ' + protocolType;
      }

      if (this.isHPCCluster) {
        this.hpcNodeCount = infos.nodeCount.slice(0, -2);
      }

      if (this.productTypeCode === 'TGW' && this.dstTgwName === '') {
        if (
          _.isObject(attrs) === false ||
          infos.dstTgwName === null ||
          (typeof infos.dstTgwName === 'undefined' &&
            Object.keys(infos).includes('dstTgwName') === false)
        ) {
          this.dstTgwName = this.monSchema.noData;
        }
      }

      if (this.isCdn && this.serviceDomain === '') {
        if (infos.serviceDomain === null) {
          this.serviceDomain = this.monSchema.noData;
        } else if (infos.serviceDomain.length > 0) {
          this.serviceDomain = infos.serviceDomain;
        }
      }

      // eslint-disable-next-line
      if (this.isDataOpsDataFlow) {
        this.dataOpsClusterName = infos.clusterName;
        this.podCount = infos.podCount === null ? this.monSchema.noData : String(infos.podCount);
      }
    },

    getProductInfoFilter() {
      this.detailFilter = _.cloneDeep(this.infoFilter);
    },

    setLabel() {
      this.monSchema = _.cloneDeep(this.labelField);
    },
    isUsePresent(value) {
      return value === 'Y' ? this.monSchema.useY : this.monSchema.useN;
    }
  }
};
</script>
